'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var ExpandMoreIcon = _interopDefault(require('@material-ui/icons/ExpandMore'));
var InputCheckbox = require('../InputCheckbox/InputCheckbox.js');
var styledComponents = require('./styled-components.js');

var getSelectedItems = function (menuItems, initiallySelected) {
    var selectedValues = {};
    menuItems.forEach(function (item) {
        if (Array.isArray(initiallySelected)) {
            selectedValues[item.value] = initiallySelected.includes(String(item.value));
        }
        else if (typeof initiallySelected === 'string') {
            selectedValues[item.value] = String(item.value) === initiallySelected;
        }
        else {
            selectedValues[item.value] = initiallySelected;
        }
    });
    return selectedValues;
};
var fmBase = 'componentLib.inputs.multiSelectMenu';
// TODO: update to use an input instead of a button for focus/hover styling
var MultiSelectMenu = function (props) {
    var menuItems = props.menuItems, title = props.title, reporter = props.reporter, _a = props.Icon, Icon = _a === void 0 ? ExpandMoreIcon : _a, _b = props.disabled, disabledInput = _b === void 0 ? false : _b, _c = props.className, className = _c === void 0 ? '' : _c, _d = props.initiallySelected, initiallySelected = _d === void 0 ? false : _d, selectAllAvailable = props.selectAllAvailable, _e = props.shouldResetState, shouldResetState = _e === void 0 ? false : _e;
    var classes = styledComponents.useStyles();
    var fm = reactIntl.useIntl().formatMessage;
    var defaultSelectedValues = getSelectedItems(menuItems, initiallySelected);
    var _f = React.useState(defaultSelectedValues), params = _f[0], setParams = _f[1];
    var _g = React__default.useState(null), anchorEl = _g[0], setAnchorEl = _g[1];
    React.useEffect(function () {
        var res = Object.keys(params).filter(function (key) { return params[key]; });
        reporter(res);
    }, [params]);
    React.useEffect(function () {
        if (shouldResetState) {
            var selectedValues = getSelectedItems(menuItems, initiallySelected);
            setParams(selectedValues);
        }
    }, [shouldResetState]);
    var changeSelection = function (value, checked) {
        var newParams = tslib.__assign({}, params);
        newParams[value] = checked;
        setParams(newParams);
    };
    var handleOpen = function (event) {
        setAnchorEl(event.currentTarget.parentElement);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleItemClick = function (value) {
        changeSelection(value, !params[value]);
    };
    var handleReset = function () {
        var selectedValues = getSelectedItems(menuItems, initiallySelected);
        setParams(selectedValues);
    };
    var handleSelectAll = function () {
        var newParams = tslib.__assign({}, params);
        Object.keys(newParams).forEach(function (key) {
            newParams[key] = true;
        });
        setParams(newParams);
    };
    return (React__default.createElement(styledComponents.Main, { className: className },
        React__default.createElement(styledComponents.StyledButton, { onClick: handleOpen, disabled: disabledInput, endIcon: React__default.createElement(Icon, null) },
            React__default.createElement(SmallDarkText, null, title)),
        React__default.createElement(styledComponents.StyledMenu, { anchorEl: anchorEl, open: !!anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, getContentAnchorEl: null, marginThreshold: 0, PopoverClasses: { paper: classes.popoverPaper }, MenuListProps: { style: { padding: '0' } } },
            menuItems.map(function (item) { return (React__default.createElement(styledComponents.StyledMenuItem, { key: item.value, onClick: function (e) {
                    e.preventDefault();
                    handleItemClick(item.value);
                } },
                React__default.createElement(InputCheckbox, { controlled: true, onChange: function (checked, event) {
                        event.preventDefault();
                        changeSelection(item.value, checked);
                    }, initiallyChecked: params[item.value], label: item.display, "data-testid": "check-" + item.value }))); }),
            selectAllAvailable && (React__default.createElement(styledComponents.StyledResetMenuItem, { onClick: handleSelectAll }, fm({ id: fmBase + ".selectAll" }))),
            React__default.createElement(styledComponents.StyledResetMenuItem, { onClick: handleReset }, fm({ id: fmBase + ".reset" })))));
};

module.exports = MultiSelectMenu;
